import { TabPanel } from '@fabric-ds/react';

import { Vertical, verticals } from '../data/verticals';

import { Destination } from '../interfaces/destination';
import { Menu } from 'shared/page/Menu';
import { Heading } from 'shared/search/Heading';
import { FlightSearch } from 'shared/search/flight/FlightSearch';
import { HotelSearch } from 'shared/search/hotel/HotelSearch';
import { PrePackageSearch } from 'shared/search/prepackage/PrePackageSearch';
import { CarSearch } from 'shared/search/car/CarSearch';
import { FhhSearch } from 'shared/search/fhh/FhhSearch';

interface Props {
    destination: Destination;
    vertical: Vertical;
    isCountry: boolean;
}

export const MenuAndSearch = ({ destination, vertical, isCountry }: Props) => {
    const displayDestination = isCountry ? destination.country : destination.city;
    const displayText = isCountry ? destination.country : `${destination.city}, ${destination.country}`;
    const destinationHierarchy = isCountry ? [destination.country] : [destination.country, destination.city];

    const renderSearch = () => {
        switch (vertical) {
            case verticals.flight:
                return (
                    <FlightSearch
                        prefill={{
                            destination: destination.airport,
                            destinationName: displayText,
                            destinationCity: destination.city,
                            destinationCountry: destination.country,
                        }}
                        position="destinationpages"
                    />
                );
            case verticals.hotel:
                return (
                    <HotelSearch
                        prefill={
                            destination.searchable
                                ? {
                                      destination: displayText,
                                      destinationContext: {
                                          text: displayDestination,
                                          key: destination.placeKey,
                                          searchable: true,
                                          hierarchy: destinationHierarchy,
                                          type: isCountry ? 'country' : 'place',
                                      },
                                  }
                                : undefined
                        }
                        position="destinationpages"
                    />
                );
            case verticals.prepackage:
                return (
                    <PrePackageSearch
                        prefill={{
                            destination: displayText,
                            destinationId: destination.locationCodes[0],
                        }}
                        position="destinationpages"
                    />
                );
            case verticals.fhh:
                return (
                    <FhhSearch
                        prefill={{
                            destination: displayText,
                            destinationData: { text: displayText },
                        }}
                        position="destinationpages"
                    />
                );
            case verticals.carrental:
                return (
                    <CarSearch
                        prefill={
                            destination.location
                                ? {
                                      pickupLocation: destination.location.text,
                                      pickupLocationId: destination.location.id,
                                      pickupLocationLatitude: destination.location.latitude,
                                      pickupLocationLongitude: destination.location.longitude,
                                  }
                                : undefined
                        }
                        position="destinationpages"
                    />
                );
        }
    };

    return (
        <>
            <Menu activeVertical={vertical} />
            <section data-testid="searchFormContent" aria-labelledby="main-heading">
                <Heading vertical={vertical} destination={displayDestination} />
                <TabPanel name={vertical}>{renderSearch()}</TabPanel>
            </section>
        </>
    );
};
